import React from "react";
//@ts-ignore
import { useTrack } from "../../../../services/hooks/useTrack";
import { ExportIcon } from "../../../../assets/icons/ExportIcon";
//@ts-ignore
import { BannerSection } from "./style";

export function ReferralBanner() {
  const { trackEvent } = useTrack();

  return (
    <BannerSection>
      <>
        <div
          className="bannerLink"
          onClick={() => {
            trackEvent('Indique - Clicou no banner compartilhar beneficio', {Parceiro: 'CRM-DF'})
            const url =
              "https://web.whatsapp.com/send?text=" +
              encodeURIComponent(
                "Oi! O CRM-DF liberou acesso gratuito ao Blackbook para médicos registrados e regulares no Conselho. Vale a pena resgatar essa ferramenta que facilita muito a rotina clínica. Aproveita! https://crmdf.org.br/noticias/crm-df-disponibiliza-plataforma-de-apoio-as-decisoes-clinicas-aos-medico-do-df"
              );
            window.open(url, "_blank");
          }}
          data-bannerType="1"
        >
        <div className="corner__text">COMPARTILHE<ExportIcon color="#fcde17" /></div>
          <div className="banner">
            <div className="textArea">
              <div className="textContainer">
                <h3>FORTALEÇA QUEM CAMINHA COM VOCÊ.</h3>
                <p>
                  Compartilhe o Blackbook com seus colegas do CRM-DF e
                  multiplique o acesso ao conhecimento que transforma a prática
                  médica.
                </p>
              </div>
              <svg
                className="svg"
                preserveAspectRatio="none"
                viewBox="286.71 248.482 193.914 117.886"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M 474.926 268.469 C 470.221 282.668 462.395 295.652 452.015 306.484 C 462.373 317.467 470.092 330.634 474.592 344.997 C 477.182 351.99 479.193 359.136 480.624 366.368 L 410.804 366.368 C 409.407 358.447 407.323 350.645 404.565 343.051 C 399.931 329.277 392.326 316.671 382.28 306.112 C 392.334 295.574 399.94 282.98 404.565 269.214 C 407.022 262.448 408.945 255.516 410.323 248.482 L 480.49 248.482 C 479.128 255.257 477.27 261.937 474.926 268.469 Z"
                  fill="#fff"
                />
                <rect
                  x="286.71"
                  y="248.482"
                  width="161"
                  height="117.886"
                  fill="#fff"
                />
              </svg>
            </div>
            <img
              className="banner__image"
              src={require("../../../../assets/images/referralBannerImage.png")}
              alt=""
            />
          </div>
        </div>
      </>
    </BannerSection>
  );
}
